import React, { useState } from "react";
import {
  MdDashboard,
  MdPayment,
  MdBedroomParent,
  MdOutlineMeetingRoom,
  MdPeople,
  MdKeyboardArrowDown,
} from "react-icons/md";
import "../AdminCommonCom/Sidebar.css";
import { NavLink } from "react-router-dom";

export default function StudentSidebar({ isOpen, toggleSidebar }) {
  const [activeItem, setActiveItem] = useState("Dashboard");
  const [openDropdown, setOpenDropdown] = useState(null);

  
  const menuItems = [
    { title: "Dashboard", icon: <MdDashboard />, path: "/student/std-dashboard" },
    
     {
      title: "User Details",
      icon: <MdPayment />,
      subItems: [
        { name: "Profile Details", path: "/student/details-profile" },
        { name: "Room-Bed Details", path: "/student/details-roomBed" },
        { name: "Payment Details", path: "/student/details-payment" },
      ],
    },
     {
      title: "Applications",
      icon: <MdPayment />,
      subItems: [
        { name: "Complaint Application", path: "/student/app-complaint" },
        { name: "Leave Application", path: "/student/app-leave" },
      ],
    },
     {
      title: "Reports",
      icon: <MdPayment />,
      subItems: [
        { name: "Attendance Report", path: "/student/report-attend" },
        { name: "Mandir Attendance Report", path: "/student/report-mandir-attend" },
        { name: "Event Attendance Report", path: "/student/report-event-attend" },
        // { name: "Report", path: "/student/report-report" },
      ],
    },
    { title: "Job Post Details", icon: <MdDashboard />, path: "/student/std-job-post" },
  ];

  const handleDropdownToggle = (title) => {
    setOpenDropdown(openDropdown === title ? null : title);
  };

  return (
    <>
      <div
        className={`overlay ${isOpen ? "show" : ""}`}
        onClick={toggleSidebar}
      />

      <aside className={`sidebar ${isOpen ? "open" : ""}`}>
        <div className="sidebar-header">
          <span className="brand-text"></span>
          <button className="close-btn" onClick={toggleSidebar}>
            ✖
          </button>
        </div>

        <nav className="nav">
          {menuItems.map((item) => (
            <div key={item.title} className="menu-group">

              {item.path ? (
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `nav-item ${isActive ? "active" : ""}`
                  }
                  onClick={() => {
                    setActiveItem(item.title);
                    toggleSidebar(); // closes sidebar on mobile
                  }}
                >
                  <div className="menu-left">
                    <span className="icon">{item.icon}</span>
                    <span className="text">{item.title}</span>
                  </div>
                </NavLink>
              ) : (
                <button
                  className={`nav-item ${
                    activeItem === item.title ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveItem(item.title);
                    handleDropdownToggle(item.title);
                  }}
                >
                  <div className="menu-left">
                    <span className="icon">{item.icon}</span>
                    <span className="text">{item.title}</span>
                  </div>

                  {item.subItems && (
                    <MdKeyboardArrowDown
                      className={`arrow  ${
                        openDropdown === item.title ? "rotate" : ""
                      }`}
                    />
                  )}
                </button>
              )}


              {/* Dropdown (flat style) */}
              {item.subItems && openDropdown === item.title && (
                <div className="submenu flat">
                  {item.subItems.map((sub) => (
                  <NavLink
                    key={sub.name}
                    to={sub.path}
                    className={({ isActive }) =>
                      `submenu-item ${isActive ? "active" : ""}`
                    }
                    onClick={toggleSidebar}
                  >
                    <span className="submenu-dot">•</span>
                    {sub.name}
                  </NavLink>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>
      </aside>
    </>
  );
}
